const api = `/api`

const AUTH = {
    LOGIN: `${api}/login`,
    SIGNUP: `${api}/signup`,
    FORGOT_PASSWORD: `${api}/forgot-password`,
    RESET_PASSWORD: `${api}/reset-password`,
    GOOGLELOGIN: `${api}/google-login`,

}

const GET = {
    GET_USERS: `${api}/get-all-users`,
    GET_DEVICES: `${api}/get-all-devices`,
    GET_VEHICLES: `${api}/get-all-vehicles`,
    VERIFY_TOKEN: `${api}/access_token`,
    GET_REPORT: `${api}/get-report`,
    GET_DEVICE_INFO: `${api}/get-device-info`,
    GET_ORGANIZATIONS: `${api}/get-organizations`,
    GET_ALL_ORGANIZATIONS: `${api}/get-all-organizations`,
    GET_ORGANIZATION_FILTER: `${api}/get-organization-filter`,
    GET_MONTH_STATS: `${api}/get-month-stats`,
    LATEST_PEOPLE_COUNTER_DATA: `${api}/latest-people-counter-data`,
    GET_MAP_HISTORY: `${api}/get-map-history`,
    GET_AVAILABLE_SERIAL_NUMBER: `${api}/get-available-serial-number`,
    GET_UNASSOCIATED_VEHICLE: `${api}/get-unassociated-vehicle`,
    GET_VALIDATORS: `${api}/get-validators`,
    GET_VALIDATORS_IP: `${api}/get-validators-ip`,
    GET_VALIDATORS_IP_AND_DETAILS: `${api}/get-validators-ip-and-details`,
    DOWNLOAD_VEHICLE_PDF: `${api}/download-vehicle-pdf`,
    DOWNLOAD_DEVICE_PDF: `${api}/download-device-pdf`,
    GET_VEHICLE_STOPS: `${api}/get-vehicle-stops`,
    GET_VEHICLE_SCHEDULE_ROUTE: `${api}/vehicle-schedule-route`,
    GET_VEHICLE_ROUTE_HISTORY: `${api}/vehicle-route-history`,
    GET_FLEET_ROUTE_HISTORY: `${api}/fleet-route-history`,
    ROUTE_FORECAST: `${api}/route-forecast`,
    GET_GTFS_FEEDS: `${api}/get-gtfs-feeds`,
    GET_GTFS_FEED_VERSIONS: `${api}/get-gtfs-feed-versions`,
    GET_GTFS_VEHICLES: `${api}/get-gtfs-vehicles`,
    GET_GTFS_LINES: `${api}/get-gtfs-lines`,
    GET_GTFS_LINE_DETAIL: `${api}/get-gtfs-line-detail`,
    GET_GTFS_LINE_SHIFTS: `${api}/get-gtfs-line-shifts`,
    // + `/<vehicleId>/assignment-history`
    VEHICLE_ASSIGNMENT_HISTORY: `${api}/vehicles`,
    GET_GTFS_TRIP_STOPS: `${api}/get-gtfs-trip-stops`,
    GET_ALL_BUS_LED: `${api}/get-all-bus-led`,
    GET_CONTROL_UNIT_SERIAL_NUMBERS: `${api}/get-control-unit-serial-numbers`,
    GET_ALL_LINES: `${api}/get-all-lines`,
    GET_ALL_LINES_DIRECTION: `${api}/get-all-lines-directions`,
    GET_GEO_FENCES: `${api}/get-geo-fences`,
    DOWNLOAD_PANEL_PDF: `${api}/get-panel-pdf`,
    GET_PARKING_HISTORY: `${api}/parking/history`,
    DOWNLOAD_PARKING_PDF: `${api}/download-parking-pdf`,
    // GET_CAMERA_MAPPING: `${api}/parking-system/get-camera-mappings`,
    GET_CAMERA_MAPPING: `${api}/NotificationInfo/getCameraMappings`,
    GET_PARKING_SESSION_BY_QR: `${api}/parking/session-by-qr`,
    GET_PARKING_AVAILABILITY: `${api}/parking/getParkingAvailability`,
    GET_PARKING_LOT: `${api}/parking/get-parking-lot`,
    GET_PARKING_SLOTS: `${api}/parking/get-parking-slots`,
}

const POST = {
    UPDATE_PASSWORD: `${api}/update-password`,
    UPDATE_PROFILE: `${api}/update-profile`,
    CHANGE_PASSWORD: `${api}/change-password`,
    ADD_USER: `${api}/add-user`,
    UPDATE_USER: `${api}/update-user`,
    DELETE_USER: `${api}/delete-user`,
    ADD_VEHICLE: `${api}/add-vehicle`,
    ADD_VEHICLE_DATA: `${api}/add-vehicles`,
    UPDATE_VEHICLE: `${api}/update-vehicle`,
    DELETE_VEHICLE: `${api}/delete-vehicle`,
    ADD_DEVICE: `${api}/add-device`,
    UPDATE_ADD_DEVICE: `${api}/update-device`,
    DELETE_DEVICE: `${api}/delete-device`,
    REPORT_FILTER: `${api}/report-filter`,
    VEHICLE_DETAILS: `${api}/vehicle-details`,
    ADD_ORGANIZATION: `${api}/add-organization`,
    UPLOAD_FILE: `${api}/uploadfile`,
    UPLOAD_VEHICLE_LOGO: `${api}/upload-vehicle-logo`,
    DELETE_ORGANIZATION: `${api}/delete-organization`,
    UPDATE_ORGANIZATION: `${api}/update-organization`,
    DOWNLOAD_PEOPLE_COUNTER_PDF: `${api}/download-people-counter-pdf`,
    DOWNLOAD_VEHICLE_REPORT_PDF: `${api}/download-vehicle-report-pdf`,
    DOWNLOAD_VEHICLE_PASEENGER_COUNTER_PDF: `${api}/download-vehicle-passenger-counter-pdf`,
    UPLOAD_GTFS: `${api}/upload-gtfs-org`,
    PREVIEW_GTFS: `${api}/preview-gtfs-org`,
    DELETE_GTFS_FEED: `${api}/delete-gtfs-feed`,
    ATTACH_GTFS_VEHICLES: `${api}/attach-gtfs-vehicles`,
    UPDATE_GTFS_FEED_NAME: `${api}/update-gtfs-feed-name`,
    RESOLVE_GTFS_STOP_COORDINATES: `${api}/resolve-gtfs-stop-coordinates`,
    DETECT_GTFS_VEHICLE_LINES: `${api}/detect-gtfs-vehicle-lines`,
    ASSIGN_GTFS_VEHICLE_LINES: `${api}/assign-gtfs-vehicle-lines`,
    // PATCH + `/<vehicleId>/reassign-trip`
    REASSIGN_VEHICLE_TRIP: `${api}/vehicles`,
    ADD_VALIDATOR: `${api}/add-validator`,
    UPDATE_VALIDATOR: `${api}/update-validator`,
    DELETE_VALIDATOR: `${api}/delete-validator`,
    DOWNLOAD_VALIDATOR_PDF: `${api}/download-validator-pdf`,
    DOWNLOAD_VALIDATOR_IP_PDF: `${api}/download-validator-ip-pdf`,
    REFRESH_VALIDATOR_DATA: `${api}/fetch-validator-data`,
    ADD_BUS_LED: `${api}/add-bus-led`,
    EDIT_BUS_LED: `${api}/edit-bus-led`,
    DELETE_BUS_LED: `${api}/delete-bus-led`,
    ADD_BUS_PANEL: `${api}/add-bus-panel`,
    UPDATE_BUS_PANEL: `${api}/update-bus-panel`,
    ADD_GEOFENCE: `${api}/add-geofence`,
    UPDATE_PARKING_SESSION: `${api}/parking/update-session`,
    CREATE_CAMERA_MAPPING: `${api}/parking/create-camera-mapping`,
    ADD_CAMERA_MAPPING: `${api}/parking/add-camera-mapping`,
    // UPDATE_CAMERA_MAPPING: `${api}/parking-system/update-camera-mapping`,
    // DELETE_CAMERA_MAPPING: `${api}/parking-system/delete-camera-mapping`,
    DELETE_CAMERA_MAPPING: `${api}/NotificationInfo/deleteCameraMappings`,
    UPDATE_CAMERA_MAPPING: `${api}/NotificationInfo/updateCameraMappings`,
    DOWNLOAD_SINGLE_PARKING_PDF: `${api}/parking/download-single-parking-pdf`,
    ADD_PARKING_LOT: `${api}/parking/add-parking-lot`,
    DELETE_PARKING_LOT: `${api}/parking/delete-parking-lot`,
    EDIT_PARKING_LOT: `${api}/parking/edit-parking-lot`,
}

export {
    AUTH,
    GET,
    POST
}
